import { z } from 'zod';
import { QTY_SCALE } from '../../utils/quantity-scale.js';
import { priorityIdSchema } from '../priority/index.js';
import { optionalNullableDateInput, requiredUuidString } from '../zod-helpers/index.js';
import { MANUFACTURING_ORDER_CONSTRAINTS } from './constraints.js';
import { isScheduledWindowOrdered } from './scheduled-window.js';
import { workOrderNoteSchema } from './work-order-note.js';
export const TICKET_WINDOW_MESSAGE = `A ticket's ${MANUFACTURING_ORDER_CONSTRAINTS.scheduledEnd.label.toLowerCase()} cannot be before its ${MANUFACTURING_ORDER_CONSTRAINTS.dateScheduledToStart.label.toLowerCase()}.`;
/**
 * One ticket as the planner cut it, travelling as one object rather than index-aligned arrays —
 * a quantity that silently takes the neighbouring ticket's window is the failure that shape
 * invites, and nothing downstream could detect it.
 */
export const ticketPlanSchema = z
    .object({
    quantity: z
        .number()
        .finite()
        .max(MANUFACTURING_ORDER_CONSTRAINTS.quantity.max, `Each work order quantity must be ${MANUFACTURING_ORDER_CONSTRAINTS.quantity.max.toLocaleString('en-US')} or less.`)
        .transform((value) => Math.round(value * QTY_SCALE) / QTY_SCALE)
        .refine((value) => value > 0, 'Each work order quantity must be greater than zero.'),
    dateScheduledToStart: optionalNullableDateInput,
    dateScheduled: optionalNullableDateInput,
    priorityId: priorityIdSchema.optional().nullable(),
    // What this particular work order is for, which the job's own note cannot say per shift.
    note: workOrderNoteSchema,
    assignedUserIds: z
        // Each element must be a real id -- see `workOrderDetailsInputSchema` for what a blank did.
        .array(requiredUuidString('An assignee is required.', 'Invalid assignee selection.'))
        .max(MANUFACTURING_ORDER_CONSTRAINTS.assignees.max, `A work order takes at most ${MANUFACTURING_ORDER_CONSTRAINTS.assignees.max} assignees.`)
        .optional()
        .nullable()
        // Sent as given, deduplicated here: the same person picked twice is one assignment.
        .transform((value) => (value == null ? undefined : [...new Set(value)])),
})
    .superRefine((ticket, context) => {
    if (!isScheduledWindowOrdered(ticket.dateScheduledToStart, ticket.dateScheduled)) {
        context.addIssue({
            code: 'custom',
            message: TICKET_WINDOW_MESSAGE,
            path: ['dateScheduled'],
        });
    }
});
//# sourceMappingURL=ticket-plan.js.map